import { getCss, buildResponsiveStyles } from '../../utils';
import { TSpacerDirection, SpacerDirectionType, TSpacerSize, SpacerSizeType } from './spacer-utils';

export const createStyles = (direction: TSpacerDirection, size: TSpacerSize): string => {
  return getCss({
    '@global': {
      ':host': buildResponsiveStyles(direction, (directionResponsive: SpacerDirectionType) => ({
        display: directionResponsive === 'horizontal' ? 'block' : 'inline-block',
        ...buildResponsiveStyles(size, (sizeResponsive: SpacerSizeType) => ({
          height: directionResponsive === 'horizontal' ? `${sizeResponsive}px` : 'auto',
          width: directionResponsive === 'horizontal' ? '100%' : `${sizeResponsive}px`,
        })),
      })),
    },
  });
};
